
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Pages where LinkedIn pixel tracking should be skipped (e.g. payment page)
const LINKEDIN_SKIP_PATHS = ['/adhesion-paiement', '/golf-paiement'];

/**
 * Safely fire a Meta Pixel PageView.
 * Retries up to maxRetries times every interval ms if fbq isn't ready yet.
 */
const trackMetaPageView = (retries = 0, maxRetries = 10, interval = 300) => {
  if (typeof (window as any).fbq === 'function') {
    (window as any).fbq('track', 'PageView');
    console.log('[MetaPixel] PageView fired ✅', window.location.pathname);
  } else if (retries < maxRetries) {
    setTimeout(() => trackMetaPageView(retries + 1, maxRetries, interval), interval);
  } else {
    console.warn('[MetaPixel] fbq not available after retries ⚠️');
  }
};

/**
 * Safely fire a LinkedIn Insight Tag PageView.
 * Retries up to maxRetries times every interval ms if lintrk isn't ready yet.
 * Skipped on payment pages.
 */
const trackLinkedInPageView = (retries = 0, maxRetries = 10, interval = 300) => {
  const currentPath = window.location.pathname;
  if (LINKEDIN_SKIP_PATHS.some(path => currentPath.includes(path))) {
    console.log('[LinkedInPixel] Skipped on payment page 🚫', currentPath);
    return;
  }
  if (typeof (window as any).lintrk === 'function') {
    (window as any).lintrk('track', { conversion_id: 0 });
    console.log('[LinkedInPixel] PageView fired ✅', currentPath);
  } else if (retries < maxRetries) {
    setTimeout(() => trackLinkedInPageView(retries + 1, maxRetries, interval), interval);
  } else {
    console.warn('[LinkedInPixel] lintrk not available after retries ⚠️');
  }
};

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  // Fire PageView on initial app mount
  useEffect(() => {
    trackMetaPageView();
    trackLinkedInPageView();
  }, []);

  // Fire PageView on every SPA route change (skip first render, handled above)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    window.scrollTo(0, 0);
    trackMetaPageView();
    trackLinkedInPageView();
  }, [pathname]);

  return null;
};
